package com.taager.circuit

import kotlinx.coroutines.CoroutineScope

@Suppress("UnnecessaryAbstractClass")
abstract class CoroutineScopeHolder {
    lateinit var scope: CoroutineScope
}
